export const currentServer: string =
  process.env.REACT_APP_CF_PAGES_URL || "https://localhost:3010";

// TODO: Not pulling in process.env.REACT_APP_API_URL correctly
export const apiUrl: string =
  process.env.REACT_APP_API_URL || "https://oliver-ktor-graphql.herokuapp.com";
